import httpClient from '../http'

export default {
  index() {
    return httpClient.get('/api/prefectures')
  }
}
